export const messages = {
  en: {
    contractDetailChange: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      contractType: 'Contract Type',
      contractTypeName: 'Contract Type',
      partyA: 'Party A',
      partyB: 'Party B',
      changeType: 'Change Type',
      planTypeName: 'Change Type',
      changePerson: 'Change Person',
      changePersonName: 'Change Person',
      applyTime: 'Apply Time',
      createTime: 'Create Time',
      description: 'Description',
      remark: 'Description',
      status: 'Status',
      stateName: 'Status',
      operation: 'Operation',
      detail: 'Detail'
    }
  },
  zh: {
    contractDetailChange: {
      contractName: '合同名称',
      contractCode: '合同编号',
      contractType: '合同类型',
      contractTypeName: '合同类型',
      partyA: '甲方',
      partyB: '乙方',
      changeType: '变更类型',
      planTypeName: '变更类型',
      changePerson: '变更人',
      changePersonName: '变更人',
      applyTime: '申请时间',
      createTime: '申请时间',
      description: '说明',
      remark: '说明',
      status: '状态',
      stateName: '状态',
      operation: '操作',
      detail: '明细'
    }
  }
}